<template>
    <div class="step-layout">
        <!-- ---------------------------- Step Intro Section ---------------------------- -->
        <section class="step-layout-left bg-6">
            <div class="step-layout-container">
                <!-- Progressbar -->
                <div class="progressbar">
                    <ul>
                        <li class="completed">Your city {{ selectedCity }}</li>
                        <li class="completed">Contact Details</li>
                        <li class="completed">Home Type</li>
                        <li class="completed">Sell Date</li>
                        <li class="active">Other Details</li>
                        <li>Home Details</li>
                    </ul>
                </div>
                <!-- Intro Title -->
                <h2
                    class="text-white intro-title d-none d-sm-block"
                    data-aos="fade-up"
                    data-aos-duration="1300"
                >
                    We can try matching your<br />
                    expectation. We give you multiple<br />
                    options to sell your home.
                </h2>
                <h2
                    class="text-white intro-title d-block d-sm-none text-center"
                    data-aos="zoom-in"
                    data-aos-duration="1300"
                >
                    We can try matching your expectation. We give you multiple
                    options to sell your home.
                </h2>
                <!-- Back Button -->
                <div
                    class="text-center text-sm-left"
                    data-aos="fade-up"
                    data-aos-duration="1600"
                >
                    <a
                        href="javascript:void(0)"
                        v-on:click="goBack()"
                        class="btn btn-primary"
                    >
                        <i class="fa-solid fa-circle-arrow-left mr-2"></i>BACK
                    </a>
                </div>
            </div>
        </section>

        <!-- -------------------------- Step Form Section -------------------------- -->
        <section class="step-layout-right">
            <div
                class="step-layout-container"
                data-aos="fade-left"
                data-aos-duration="1500"
            >
                <!-- Title -->
                <h2 class="text-primary title" v-html="valuationTitle"></h2>

                <!-- Price Slider -->
                <!-- <div class="price-range px-4 py-4 bg-light">
                    <div class="range-slider">
                        <div class="text-center">
                            <p class="selected-price-range"></p>
                        </div>
                        <input type="text" class="js-range-slider" value="" />
                        <input
                            type="hidden"
                            class="js-input-from form-control"
                            value="0"
                        />
                        <input
                            type="hidden"
                            class="js-input-to form-control"
                            value="0"
                        />
                        <div
                            class="d-flex justify-content-between align-items-center mt-2 mx-1"
                        >
                            <small class="price-label-from text-muted"></small>
                            <small class="price-label-to text-muted"></small>
                        </div>
                    </div>
                </div> -->

                <!-- <range-slider
                    class="slider"
                    min="300000"
                    max="3000000"
                    step="1000"
                    v-model="sliderValue"
                ></range-slider>
                <div class="row">
                    <div class="col-4 text-left">$300,000</div>
                    <div class="col-4 text-center">${{ sliderValue | numberWithCommas }}</div>
                    <div class="col-4 text-right">$3,000,000</div>
                </div> -->
                <div class="">
                    <div class="form-group row align-items-center">
                        <label for="min-price" class="col-4">Min Price</label>
                        <input type="number" class="form-control col-6" id="min-price" placeholder="CAD" min="300000" max="3000000" v-model="valuation_from_price">
                        <span class="col">$</span>
                    </div>
                    <div class="form-group row align-items-center">
                        <label for="max-price" class="col-4">Max Price</label>
                        <input type="number" class="form-control col-6" id="max-price" placeholder="CAD" min="300000" max="3000000" v-model="valuation_to_price">
                        <span class="col">$</span>
                    </div>
                </div>
                <div class="text-left text-lg-right submit-btn-wrapper">
                    <button type="button" class="btn btn-primary btn-lg submit-btn" @click="submitForm">
                    Continue
                    </button>
                </div>
            </div>
        </section>
    </div>
</template>

<script>
import RangeSlider from 'vue-range-slider';
// you probably need to import built-in style
import 'vue-range-slider/dist/vue-range-slider.css';
export default {
    name: "PropertyValuationStepSix",
    data() {
        return {
            valuationStep: 6,
            selectedCity: "Toronto",
            selectedAddress: "",
            name: "",
            email: "",
            phone: "",
            propertyType: "Detached",
            sellFrequency: "As soon as possible",
            basePresent: "Yes",
            anotherHouseBuyPlan: "Yes",
            sliderValue: 300000,
            utm_source: "RedBuyers",
            utm_medium: "redbuyers.com",
            utm_campaign: "IN_HOUSE",
            utm_id: "REDBUYERS",
            utm_content: "Sixth Step",
            valuationTitle: "What is your expected price?",
            valuation_from_price:300000,
            valuation_to_price:""
        };
    },
    components: {
        RangeSlider
    },
    mounted() {
        if (sessionStorage.getItem("valuation_city")) {
            this.selectedCity = sessionStorage.getItem("valuation_city");
        }
        if (sessionStorage.getItem("valuation_address")) {
            this.selectedAddress = sessionStorage.getItem("valuation_address");
        }
        //step-1 data
        if (sessionStorage.getItem('valuation_name')) {
            this.name = sessionStorage.getItem('valuation_name');
        }
        if (sessionStorage.getItem('valuation_email')) {
            this.email = sessionStorage.getItem('valuation_email');
        }
        if (sessionStorage.getItem('valuation_phone')) {
            this.phone = sessionStorage.getItem('valuation_phone');
        }
        //step-2 data
        if (sessionStorage.getItem("valuation_property_type")) {
            this.propertyType = sessionStorage.getItem("valuation_property_type");
        }
        //step-3 data
        if (sessionStorage.getItem("valuation_sell_frequency")) {
            this.sellFrequency = sessionStorage.getItem("valuation_sell_frequency");
        }
        //step-4 data
        if (sessionStorage.getItem("valuation_basement_present")) {
            this.basePresent = sessionStorage.getItem("valuation_basement_present");
        }
        //step-5 data
        if (sessionStorage.getItem("valuation_another_house_buy_plan")) {
            this.anotherHouseBuyPlan = sessionStorage.getItem("valuation_another_house_buy_plan");
        }
        //step-6 data
        // if(sessionStorage.getItem('valuation_to_price')) {
        //     this.sliderValue = sessionStorage.getItem('valuation_to_price');
        // }
        if(sessionStorage.getItem('valuation_to_price')) {
            this.valuation_to_price = sessionStorage.getItem('valuation_to_price');
        }
        //other
        if(sessionStorage.getItem('valuation_utm_source')) {
            this.utm_source = sessionStorage.getItem('valuation_utm_source');
        }
        if(sessionStorage.getItem('valuation_utm_medium')) {
            this.utm_medium = sessionStorage.getItem('valuation_utm_medium');
        }
        if(sessionStorage.getItem('valuation_utm_campaign')) {
            this.utm_campaign = sessionStorage.getItem('valuation_utm_campaign');
        }
        if(sessionStorage.getItem('valuation_utm_id')) {
            this.utm_id = sessionStorage.getItem('valuation_utm_id');
        }
        if(sessionStorage.getItem('valuation_utm_content')) {
            this.utm_content = sessionStorage.getItem('valuation_utm_content');
        }
        if(sessionStorage.getItem('valuation_data')) {
            sessionStorage.removeItem('valuation_data');
        }
    },
    methods: {
        submitForm() {
            sessionStorage.setItem('valuation_from_price', 300000);
            // sessionStorage.setItem('valuation_to_price', this.sliderValue);
            sessionStorage.setItem('valuation_to_price', this.valuation_to_price);
            window.location.href = "/properties/valuation/submit/data/step-7";
        },
        goBack() {
            window.location.href = "/properties/valuation/submit/data/step-5";
        }
    },
    filters: {
        numberWithCommas(x) {
            return x.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
        }
    }
};
</script>

<style scoped>
@import '~vue-range-slider/dist/vue-range-slider.scss';
.slider {
  /* overwrite slider styles */
  width: 100%;
}
</style>

<style>
.range-slider.slider>.range-slider-inner>.range-slider-fill {
    background-color: #007bff;
}
</style>